import { matchURLAggregationRule, } from "@adora/backend-api";
import { unreachable } from "@adora/lib";
import { minimatch } from "minimatch";
import { urlAccepted } from "./url-accepted";
/**
 * redactURL redacts any relevant url parameters.
 *
 * @params urlString: the url, in string form.
 * @params allowedSearchParams: a map from search param keys
 * (supports minimatch format) to allowed paths (also supports minimatch format).
 */
export function redactURL(urlString, allowedSearchParams, pathConfig) {
    let url = urlAccepted({
        urlStr: urlString,
        pathConfig,
    });
    if (!url) {
        // Temporarily allow this, just in case.
        url = new URL(urlString);
        //throw new Error(`expected path to not be blocked, but got ${urlString}`);
    }
    const pathAllowedRules = findMatchingRule(url.pathname, allowedSearchParams.rules || []);
    const toDelete = [];
    for (const searchParam of url.searchParams.keys()) {
        const action = searchParamAction(searchParam, pathAllowedRules?.rules || []);
        switch (action) {
            case "accept":
                break;
            case "delete":
                toDelete.push(searchParam);
                break;
            case "anonymize":
                url.searchParams.set(searchParam, "*");
                break;
            default:
                unreachable(action);
        }
    }
    for (const key of toDelete) {
        url.searchParams.delete(key);
    }
    // Strip accidentally included %3F.
    // See: ADORA-476
    if (url.pathname.includes("%3F")) {
        const exploded = url.pathname.split("/");
        exploded[exploded.length - 1] =
            exploded[exploded.length - 1].split("%3F")[0];
        url.pathname = exploded.join("/");
    }
    // Usually `=` is a query param. For now, avoid them entirely.
    if (url.hash.includes("=")) {
        url.hash = "";
    }
    return url.toString();
}
function findMatchingRule(pathname, rules) {
    for (const rule of rules) {
        if (matchURLAggregationRule(pathname, { path: rule.path })) {
            return rule;
        }
    }
    return undefined;
}
function searchParamAction(searchParam, rules) {
    for (const rule of rules) {
        if (minimatch(searchParam, rule.param)) {
            if (rule.anonymizeValue) {
                return "anonymize";
            }
            return "accept";
        }
    }
    return "delete";
}
